import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import  TableIndicators  from "./components/table-indicators/TableIndicators";

export function IndicatorsRegisterPage() {
    return (
        <ToastProvider>
            <Dashboard>
                <TableIndicators/>
            </Dashboard>
            <Toast />
        </ToastProvider>
    );
}
